import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

export function ThemeToggle({ compact }: { compact?: boolean }) {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === 'light';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="flex items-center gap-2 rounded-lg border border-[var(--sala-border-strong)] px-2.5 py-1.5 text-xs font-semibold transition hover:border-[var(--sala-accent)]"
      style={{ background: 'var(--sala-surface-raised)', color: 'var(--sala-ink-muted)' }}
      title={isLight ? 'Cambiar a modo oscuro' : 'Cambiar a modo claro'}
      aria-label={isLight ? 'Activar modo oscuro' : 'Activar modo claro'}
    >
      <span aria-hidden>{isLight ? '☀️' : '🌙'}</span>
      {!compact && <span>{isLight ? 'Claro' : 'Oscuro'}</span>}
    </button>
  );
}
